import React, { useEffect, useState } from "react";
import { useLanguage } from "../Context/LanguageContext";
import "./Contacts.css";


const CONTACTS_API_URL =
    "https://script.google.com/macros/s/AKfycbybnAacNojJ9KqgTcOG7acH0X9gmgXeiN7XtRAyAq5Z7C3wnttAeALCt0Q1peVxR3AX/exec";


function Contacts() {

    const { language } = useLanguage();

    const [contacts, setContacts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");


    /* =====================================================
       LOAD CONTACTS
    ===================================================== */

    useEffect(() => {

        const loadContacts = async () => {

            try {

                setLoading(true);
                setError("");


                const response =
                    await fetch(CONTACTS_API_URL);


                if (!response.ok) {

                    throw new Error(
                        "Unable to load contacts."
                    );

                }


                const data =
                    await response.json();


                if (!data.success) {

                    throw new Error(
                        data.error ||
                        "Unable to load contacts."
                    );

                }


                setContacts(
                    data.contacts || []
                );

            } catch (error) {

                console.error(error);

                setError(
                    error.message
                );

            } finally {

                setLoading(false);

            }

        };


        loadContacts();

    }, []);


    /* =====================================================
       PHONE LINK
    ===================================================== */

    const getPhoneLink = (phone) => {

        if (!phone) {
            return "";
        }


        return String(phone)
            .replace(/\s+/g, "")
            .replace(/-/g, "");

    };


    return (

        <main className="contacts-page">


            {/* =========================================
                HERO
            ========================================= */}

            <section className="contacts-header">

                <div className="container contacts-header-content">

                    <span className="contacts-header-label">

                        {language === "bn"
                            ? "যোগাযোগ"
                            : "Contact Us"}

                    </span>


                    <h1>

                        {language === "bn"
                            ? "আমাদের সাথে যোগাযোগ করুন"
                            : "Get in Touch With Us"}

                    </h1>


                    <p>

                        {language === "bn"
                            ? "আমরা-আমরা সম্পর্কে কোনো প্রশ্ন, পরামর্শ অথবা সহযোগিতার জন্য আমাদের সাথে যোগাযোগ করুন।"
                            : "Contact us if you have any questions, suggestions, or would like to get involved with Amra-Amra."}

                    </p>

                </div>

            </section>


            {/* =========================================
                CONTACTS
            ========================================= */}

            <section className="contacts-section">

                <div className="container">


                    {/* SECTION HEADING */}

                    <div className="contacts-section-heading">

                        <span>

                            {language === "bn"
                                ? "আমাদের টিম"
                                : "Our Team"}

                        </span>


                        <h2>

                            {language === "bn"
                                ? "যোগাযোগের ব্যক্তিবর্গ"
                                : "Contact Persons"}

                        </h2>


                        <p>

                            {language === "bn"
                                ? "প্রয়োজনে নিচের যেকোনো একজনের সাথে যোগাযোগ করতে পারেন।"
                                : "You are welcome to contact any of the people below."}

                        </p>

                    </div>


                    {/* =================================
                        LOADING
                    ================================= */}

                    {loading && (

                        <div className="contacts-status">

                            <div className="contacts-loader"></div>

                            <p>

                                {language === "bn"
                                    ? "যোগাযোগের তথ্য লোড হচ্ছে..."
                                    : "Loading contact information..."}

                            </p>

                        </div>

                    )}


                    {/* =================================
                        ERROR
                    ================================= */}

                    {!loading && error && (

                        <div className="contacts-status contacts-error">

                            <h3>

                                {language === "bn"
                                    ? "তথ্য লোড করা যায়নি"
                                    : "Unable to load contacts"}

                            </h3>

                            <p>
                                {error}
                            </p>

                        </div>

                    )}


                    {/* =================================
                        EMPTY
                    ================================= */}

                    {!loading &&
                        !error &&
                        contacts.length === 0 && (

                            <div className="contacts-status">

                                <h3>

                                    {language === "bn"
                                        ? "কোনো যোগাযোগের তথ্য পাওয়া যায়নি"
                                        : "No contact information available"}

                                </h3>

                            </div>

                        )}


                    {/* =================================
                        CONTACT CARDS
                    ================================= */}

                    {!loading &&
                        !error &&
                        contacts.length > 0 && (

                            <div className="contacts-grid">

                                {contacts.map(
                                    (contact, index) => (

                                        <article
                                            className="contact-card"
                                            key={
                                                contact.id ||
                                                contact.phone ||
                                                index
                                            }
                                        >


                                            {/* AVATAR */}

                                            <div className="contact-avatar">

                                                {contact.name
                                                    ? contact.name
                                                        .trim()
                                                        .charAt(0)
                                                        .toUpperCase()
                                                    : "A"}

                                            </div>


                                            {/* INFO */}

                                            <div className="contact-info">

                                                <h3>
                                                    {contact.name}
                                                </h3>


                                                {/* PHONE */}

                                                {contact.phone && (

                                                    <a
                                                        href={`tel:${getPhoneLink(
                                                            contact.phone
                                                        )}`}
                                                        className="contact-phone"
                                                    >

                                                        <span>
                                                            ☎
                                                        </span>

                                                        {contact.phone}

                                                    </a>

                                                )}


                                                {/* EMAIL */}

                                                {contact.email && (

                                                    <a
                                                        href={`mailto:${contact.email}`}
                                                        className="contact-email"
                                                    >

                                                        <span>
                                                            ✉
                                                        </span>

                                                        {contact.email}

                                                    </a>

                                                )}


                                                {/* ADDRESS */}

                                                {contact.address && (

                                                    <div className="contact-address">

                                                        <span>
                                                            ●
                                                        </span>

                                                        <span>
                                                            {contact.address}
                                                        </span>

                                                    </div>

                                                )}

                                            </div>

                                        </article>

                                    ))}

                            </div>

                        )}

                </div>

            </section>

        </main>

    );

}


export default Contacts;